import { jwtDecode } from 'jwt-decode';
import axiosIns from '@/axios';

export default {
  namespaced: true,
  state: {
    accessToken: localStorage.getItem('accessToken') || null,
    userData: JSON.parse(localStorage.getItem('userData')) || null,
    customerInfo: JSON.parse(localStorage.getItem('customerInfo')) || null,
    customers: JSON.parse(localStorage.getItem('customers')) || null,
  },
  getters: {
    role: state => {
      if (state.accessToken) {
        try {
          const decoded = jwtDecode(state.accessToken);
          return decoded.role || null;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    // Alt yapı platformu
    isTsoft: state => state.customerInfo?.platform_id === 1,
    isShopify: state => state.customerInfo?.platform_id === 2,
    isTicimax: state => state.customerInfo?.platform_id === 3,

    // Rol bazlı getterlar
    isAdmin: (state, getters) => getters.role === 'admin',
    isDeveloper: (state, getters) => getters.role === 'developer',
    isFenomen: (state, getters) => getters.role === 'influencer',
    isSaleTeam: (state, getters) => getters.role === 'sales_team',
    userData: state => state.userData,
  },
  mutations: {
    SET_LOGIN(state, data) {
      state.accessToken = data.token;
      state.userData = data.userData;
      state.customers = data.customer;
      localStorage.setItem('accessToken', state.accessToken);
      localStorage.setItem('userData', JSON.stringify(state.userData));
      localStorage.setItem('customers', JSON.stringify(state.customers));
      this.commit('user/SET_CUSTOMER', data.customer[0]);
    },
    SET_SWITCH_CUSTOMER(state, data) {
      state.accessToken = data.token;
      state.userData = data.userData;

      // Aktif müşteri güncellenir
      this.commit('user/SET_CUSTOMER', data.customer);

      // LocalStorage güncelle
      localStorage.setItem('accessToken', state.accessToken);
      localStorage.setItem('userData', JSON.stringify(state.userData));
    },
    SET_CUSTOMER(state, customer) {
      state.customerInfo = customer;
      localStorage.setItem('customerInfo', JSON.stringify(state.customerInfo));
    },
    LOGOUT_USER(state) {
      state.accessToken = null;
      state.userData = null;
      state.customerInfo = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userData');
      localStorage.removeItem('customerInfo');
      localStorage.removeItem('customers');
    },
    UPDATE_USER_DATA_ID(state, newId) {
      if (state.userData) {
        state.userData.id = newId;
        localStorage.setItem('userData', JSON.stringify(state.userData));
      }
    }
  },
  actions: {
    async setCustomerAndFetchSettings({ commit,state, dispatch }, customer) {
      commit('SET_CUSTOMER', customer);

      // // userData güncellemesini burada yap
      // if (!this.getters['user/isDeveloper']) {
      //   try {
      //     const response = await axiosIns.get('/user', {
      //       params: {
      //         filter: {
      //           email: state.userData.email,
      //         },
      //         user_type: state.userData.role,
      //       },
      //     });

      //     const newId = response.data?.data?.[0]?.id;
      //     if (newId) {
      //       commit('UPDATE_USER_DATA_ID', newId);
      //     }
      //   } catch (error) {
      //     console.error('Kullanıcı verisi çekilirken hata oluştu:', error);
      //   }
      // }

      // Ayarları çek
      // await dispatch('settings/fetchSettings', null, { root: true });
    }
  },
};